import { useMemo } from 'react'
import { useAuth } from './useAuth'
import { useOngoingChallenges } from './useOngoingChallenges'
import { UserService } from '@duck/api-definitions'

const CANDIDATE_SOURCES: Array<UserService.UserSource> = [
  UserService.UserSource.PartnerCandidate,
  UserService.UserSource.PublicCandidate,
]

export const useShowJoinGamma = () => {
  const { isAuthenticated, user, isPartner } = useAuth()
  const { hasFinishedAssignment } = useOngoingChallenges()

  return useMemo(() => {
    const hasGamma = Boolean(user?.accessGroups?.includes('Gamma'))
    const isCandidateSource = Boolean(
      user?.source && CANDIDATE_SOURCES.includes(user.source)
    )
    const isEligibleForGamma =
      isAuthenticated && isCandidateSource && !hasGamma
    const showJoinGammaCta =
      isEligibleForGamma && !isPartner && hasFinishedAssignment

    return {
      showJoinGammaCta,
      isEligibleForGamma,
      hasGamma,
      isCandidateSource,
    }
  }, [isAuthenticated, user?.source, user?.accessGroups, isPartner, hasFinishedAssignment])
}
